import { BaseModel } from '~/models/baseModel';

export class ContentLinkModel extends BaseModel {
    public name:string;
    public url:string;
}
